import { z } from 'zod';
import { zfd } from 'zod-form-data';
import { isCreditClaim } from '~/utils/claim-line-item';
import { ResolutionMethod } from '~/utils/constants';
import { makeCrewClaimAction, redirect } from '~/utils/routing';

export const FIELD_KEY = 'resolution';

const formSchema = zfd.formData({
  [FIELD_KEY]: zfd.text(
    z.union([
      z.literal(ResolutionMethod.refund),
      z.literal(ResolutionMethod.giftCard),
    ]),
  ),
});

export const { action, useActionResult: useRefundOptionsActionResult } =
  makeCrewClaimAction(({ formData, context: { crewClaim } }, appStore) => {
    const result = formSchema.safeParse(formData);

    if (!result.success) {
      return new Error('Malformed form data', {
        cause: {
          error: result.error,
          entries: Array.from(formData.entries()),
        },
      });
    }

    const { resolution } = result.data;

    crewClaim.claimLineItems.filter(isCreditClaim).forEach((cli) => {
      appStore.dispatch(
        appStore.actions.crewClaim.upsertClaimLineItem({
          ...cli,
          requestedResolutionMethodEnum: resolution,
        }),
      );
    });

    return redirect('../address');
  });
